import { DataGrid } from '@mui/x-data-grid';

import './Datatable.scss';

interface IDatatableProps {
  columns: any;
  rows: any;
  pageSize?: number;
  rowsPerPage?: number;
}

const Datatable: React.FunctionComponent<IDatatableProps> = ({ rows, columns, pageSize = 9, rowsPerPage = 9 }) => {
  return (
    <>
      <DataGrid style={{ height: '88vh' }} rows={rows} columns={columns} pageSize={pageSize} rowsPerPageOptions={[rowsPerPage]} checkboxSelection />
    </>
  );
};

export { Datatable };
